/**
 * OrdineCreatePage — Pagina dedicata per la creazione ordine.
 *
 * Accessibile da /ordini/nuovo.
 * Usa il CreaOrdineForm esistente, wrappato in una pagina standalone
 * con navigazione back alla dashboard.
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OrderWizardMSSP from '../Components/OrderWizard/OrderWizardMSSP';
import DescriptionBanner from '../Components/DescriptionBanner';

export default function OrdineCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [createdOrder, setCreatedOrder] = useState(null);

  const handleSuccess = (response) => {
    setCreatedOrder(response);
    setSuccess(true);
  };

  if (success && createdOrder) {
    return (
      <div className="space-y-4 sm:space-y-6 p-2 sm:p-4 lg:p-6">
        <DescriptionBanner
          title={t('reseller.ordineCreato', 'Ordine Creato')}
          description={t('reseller.ordineSuccesso', 'L\'ordine è stato creato con successo.')}
        />

        <div className="bg-white rounded-lg shadow p-6 max-w-lg mx-auto text-center space-y-4">
          <div className="text-green-500 text-5xl mb-2">✓</div>
          <h2 className="text-xl font-bold text-gray-800">
            {t('reseller.ordineConferma', 'Ordine confermato!')}
          </h2>

          {createdOrder.numero_ordine && (
            <p className="text-sm text-gray-600">
              Numero ordine: <span className="font-mono font-bold">{createdOrder.numero_ordine}</span>
            </p>
          )}

          <div className="grid grid-cols-2 gap-3 text-sm text-left mt-4">
            {createdOrder.azienda_info?.nome_azienda && (
              <div className="bg-gray-50 p-3 rounded">
                <p className="text-xs text-gray-500">Azienda</p>
                <p className="font-semibold">{createdOrder.azienda_info.nome_azienda}</p>
              </div>
            )}
            {createdOrder.stato_ordine && (
              <div className="bg-gray-50 p-3 rounded">
                <p className="text-xs text-gray-500">Stato</p>
                <p className="font-semibold">{createdOrder.stato_ordine}</p>
              </div>
            )}
            {createdOrder.numero_endpoint != null && (
              <div className="bg-gray-50 p-3 rounded">
                <p className="text-xs text-gray-500">Endpoint</p>
                <p className="font-semibold">{createdOrder.numero_endpoint}</p>
              </div>
            )}
            {createdOrder.totale_importo != null && (
              <div className="bg-gray-50 p-3 rounded">
                <p className="text-xs text-gray-500">Totale</p>
                <p className="font-semibold text-green-600">{createdOrder.totale_importo} €</p>
              </div>
            )}
          </div>

          <div className="flex gap-3 justify-center mt-6">
            <button
              onClick={() => { setSuccess(false); setCreatedOrder(null); }}
              className="px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-md transition-colors"
            >
              {t('reseller.creaNuovo', 'Crea un altro ordine')}
            </button>
            <button
              onClick={() => navigate('/dashboardMSSP')}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-md transition-colors"
            >
              {t('reseller.tornaDashboard', 'Torna alla Dashboard')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6 p-2 sm:p-4 lg:p-6">
      <DescriptionBanner
        title={t('reseller.nuovoOrdine', 'Nuovo Ordine')}
        description={t('reseller.nuovoOrdineDesc', 'Compila il form per creare un nuovo ordine per un\'azienda cliente.')}
      />

      <div className="flex justify-between items-center">
        <button
          onClick={() => navigate('/dashboardMSSP')}
          className="flex items-center gap-2 bg-white text-gray-800 shadow-md hover:shadow-lg transition-all duration-300 px-3 py-2 rounded-md active:scale-95"
        >
          ← {t('reseller.tornaDashboard', 'Torna alla Dashboard')}
        </button>
      </div>

      <OrderWizardMSSP
        onSubmitSuccess={handleSuccess}
        onClose={() => navigate('/dashboardMSSP')}
      />
    </div>
  );
}
